import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'Components/ComponentLibrary/Styles';
import MuiAvatar from '@material-ui/core/Avatar';

const styles = () => ({
  root: {},
});

const Avatar = ({
  classes,
  avatar,
}) => {
  return (
    <MuiAvatar className={classes.root}>
      {avatar}
    </MuiAvatar>
  );
};

Avatar.defaultProps = {
};

Avatar.propTypes = {
  avatar: PropTypes.node.isRequired,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Avatar);
